export enum SortingEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}
